import { isMobile, isTablet } from 'react-device-detect';
import styled from 'styled-components';

// :)
const COLORS = {
	primary: '#D6C06C',
	secondary: '#EECD01',
	green: '#43B726',
	white: '#fff',
	gold: '#F8EFD7',
	red: '#F8EFD7'
};

const FONTS = {
	huge: '40px',
	big: '32px',
	medium: '24px',
	small: '20px',
	xsmall: '16px'
};
export const InfoContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100dvh;
	transform: translate(0, 0);
	font-family: 'poppins-regular';
	background: linear-gradient(
		108.78deg,
		rgb(5 27 30 / 80%) 0.39%,
		rgb(3 5 17 / 80%) 100%
	);
	overflow: hidden;
	animation: enter 0.3s linear forwards;
	@media only screen and (min-width: 1024px) {
		top: 50%;
		left: 50%;
		width: 80%;
		height: 80dvh;
		transform: translate(-50%, -50%);
		border-radius: 8px;
		animation: entersm 0.3s linear forwards;
	}

	@keyframes enter {
		0% {
			height: 0;
		}
		100% {
			height: 100dvh;
		}
	}
	@keyframes entersm {
		0% {
			height: 0;
		}
		100% {
			height: 80dvh;
		}
	}
`;

export const HeaderContainer = styled.div`
	width: 100%;
	position: relative;
	background: linear-gradient(
		108.78deg,
		rgb(5 27 30 / 80%) 0.39%,
		rgb(3 5 17 / 80%) 100%
	);
	padding: 10px 0;
	border-radius: 8px;
	border-bottom: solid 1px
		linear-gradient(
			108.78deg,
			rgba(5, 14, 17, 0.8) 0.39%,
			rgba(4, 47, 50, 0.8) 100%
		);

	.title {
		color: ${COLORS.gold};
		font-size: ${FONTS.big};
		font-family: 'Japanese';
		text-align: center;
		padding: 5px;
		margin: 0;
		letter-spacing: 4px;
		stroke: #ca9e38;
		stroke-width: 2;
	}
	.icon {
		position: absolute;
		display: flex;
		right: 10px;
		bottom: 50%;
		transform: translate(0, 50%);
		cursor: pointer;
		:hover {
			opacity: 0.8;
		}
	}
	@media only screen and (min-width: 768px) {
		.title {
			font-size: ${FONTS.huge};
		}
	}
`;

export const MainContainer = styled.div`
	height: 90%;
	overflow: scroll;
	overflow-x: hidden;
	padding: 15px;

	color: ${COLORS.primary};
	&&::-webkit-scrollbar {
		width: ${(p) => (!isMobile && !isTablet ? `4px` : '0')};
		background-color: black;
		border-radius: 11px;
	}
	&&::-webkit-scrollbar-thumb {
		background-color: #137073;
		border-radius: 11px;
	}
	&&::-webkit-scrollbar-thumb:hover {
		background-color: #1e9fa3;
	}
	&&::-webkit-scrollbar-track {
		background-color: #061014;
		border-radius: 11px;
	}
	.wrapper {
		margin-top: 20px;
		max-width: 1064px;
		margin: 20px auto;
	}
	.interface_wrapper {
		max-width: 740px;
		margin: auto;
	}
	span {
		img {
			vertical-align: middle;
		}
	}

	.content {
		text-align: center;
	}

	.additional_content {
		flex: 0 0 50%;
	}

	.title {
		color: ${COLORS.secondary};
		font-size: ${FONTS.small};
		white-space: nowrap;
		text-transform: uppercase;
		margin-bottom: 20px;
	}
	.description {
		color: ${COLORS.primary};
		font-size: ${FONTS.xsmall};
		padding: 10px;
	}

	.features_wrapper {
		max-width: 1060px;
		display: flex;
		flex-wrap: wrap;
		margin: auto;
		justify-content: center;
		.features_box {
			max-width: 450px;
			text-align: center;
			justify-content: space-between;
			display: flex;
			flex-direction: column;
		}

		.bonus_icon {
			position: relative;
			background: #07242d;
			border: dashed 1px #ca9e38;
			border-radius: 4px;
			height: 103px;
			width: 320px;
			margin: auto;
			.background_img {
				position: absolute;
				right: -2px;
				top: -13px;
				width: 122px;
			}
			.bonus_text {
				position: absolute;
				top: 25px;
				left: 15px;
			}
			.bonus_amount {
				position: absolute;
				top: 48px;
				left: 15px;
				font-size: ${FONTS.big};
				font-family: 'Japanese';
				color: ${COLORS.red};
				stroke: #cfdbb5;
				stroke-width: 4;
			}
		}
		.feature_icon {
			position: relative;
			background: #07242d;
			border: dashed 1px #ca9e38;
			border-radius: 4px;
			height: 163px;
			width: 320px;
			margin: 30px auto;
			img {
				max-width: 146px;
				width: 100%;
			}
			.background_img {
				position: absolute;
				width: 188px;
				bottom: 1px;
				right: -10px;
			}
			.switch {
				width: 70px;
				position: absolute;
				bottom: 15px;
				left: 24px;
			}
			.amount {
				position: absolute;
				left: 24px;
				top: 24px;
				font-size: 24px;
				font-family: 'Japanese';
				color: ${COLORS.red};
				stroke: #cfdbb5;
				stroke-width: 4;
			}
			.text {
				position: absolute;
				left: 24px;
				bottom: 61px;
				text-align: left;
				.green {
					color: #e5c601;
				}
			}
		}
		@media only screen and (min-width: 768px) {
			.title {
				font-size: ${FONTS.medium};
			}
			.description {
				font-size: ${FONTS.small};
			}
		}
	}

	.interface_description {
		display: flex;
		align-items: center;
		font-size: ${FONTS.xsmall};
		position: relative;
		img {
			vertical-align: middle;
		}
		.interface_betamount_currency {
			position: absolute;
			left: 30px;
			top: 38px;
			font-size: 12px;
		}
		.interface_betamount {
			position: absolute;
			left: 30px;
			top: 56px;
			font-size: 24px;
			font-family: 'Japanese';
			color: ${COLORS.red};
			stroke: #cfdbb5;
			stroke-width: 4;
		}
		span {
			max-width: 400px;
		}
	}
	.description-sm {
		color: ${COLORS.primary};
		font-size: ${FONTS.xsmall};
		padding: 10px;
	}

	.additional_symbol_wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		max-width: 1060px;
		margin: auto;
	}
	.additional_symbol_box {
		flex: 0 0 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		@media only screen and (min-width: 580px) {
			flex: 0 0 50%;
		}
	}

	.symbol_box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		width: 100%;
		height: 100%;
		padding: 4px;
	}
	.symbol {
		max-width: 100px;
		min-width: 60px;
		width: 100%;
		display: flex;
		img {
			width: 100%;
		}
	}
	.additional {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 8px;
		width: 310px;
		margin: auto;
		height: 100%;
		border: none;
		padding: 4px;
		.symbol {
			max-width: 100px;
			min-width: 100px;
		}
	}

	.coefs {
		display: flex;
		justify-content: flex-start;
		text-align: left;
		span {
			color: ${COLORS.green};
			font-size: ${FONTS.xsmall};
			margin-right: 4px;
		}
		p {
			color: ${COLORS.white};
			font-size: ${FONTS.xsmall};
			white-space: nowrap;
		}
	}

	.img_box {
		max-width: 1060px;
		margin: 20px auto;
		position: relative;
		font-family: 'Japanese';
		font-size: ${FONTS.small};
		color: 45px;
		img {
			width: 100%;
		}
	}
	.small {
		max-width: 300px;
		margin: 20px auto;
		img {
			width: 100%;
		}
	}
	.yellow {
		color: #ceee71;
	}
	.blue {
		color: #3ba4f0;
	}
	.purple {
		color: #4559eb;
	}
	.pink {
		color: #fa7394;
	}

	.key_wrapper {
		display: flex;
		justify-content: center;
		max-width: 700px;
		margin: auto;
		flex-wrap: wrap;

		.key_content {
			margin-top: 10px;
			display: flex;
			align-items: center;
			flex: 1 1 300px;
			font-size: ${FONTS.xsmall};
			.key_desc {
				margin-left: 4px;
				white-space: nowrap;
			}
			img {
				height: 100%;
				max-height: 50px;
				vertical-align: middle;
			}

			@media only screen and (min-width: 560px) {
				flex: 1 1 300px;
			}
		}
	}
`;

export const SymbolWrapper = styled.div`
	.content_wrapper {
		display: flex;
		justify-content: center;
	}
	.symbol_container {
		max-width: 1064px;
		margin: auto;
		/* display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    padding: 20px; */

		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		padding: 20px;
		justify-content: center;
		align-items: center;
	}

	.symbol_wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 0 1 200px; /* Adjust the base width to 200px */
	}
	.coefs_wrapper {
		display: flex;
		flex-direction: column-reverse;
	}
`;
